import {
  Button,
  Col,
  Divider,
  Form,
  Icon,
  Input,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  Typography,
  notification,
} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { ColumnProps } from 'antd/lib/table';
import _ from 'lodash';
import moment from 'moment';
import { InfoList, LongTextTd, O2OCustomPaging } from 'o2o_layout';
import * as React from 'react';
import { BIGDATA_CONSTANT } from '../../../common/constant';
import { getCurrentURL, getPrimaryColor } from '../../../common/helper';
import DrawerViewJSON from '../../../shares/DrawerViewJSON';
import { O2OFormItem } from '../../../shares/O2OFormItem';
import { PermissionGroupsProps } from './PerminssionGroupContainer';
import { IPermissionGroupCriteria, PermissionDAL } from './dal/PermissionDAL';
import { TypePermission, TypePermissionGroup } from './model/permissions';
import DrawerCreatePermissionGroup from './DrawerCreatePermissionGroup';
import DrawerAssignUser from './drawer/DrawerAssignUser';
import SuggestionAccount from './components/SuggestionAccount';
import SuggestionPermissionGroup from './components/SuggestionPermissionGroup';
import DrawerPermission from './drawer/DrawerPermission';
import DrawerPermissionGroupInfo from './drawer/DrawerPermissionGroupInfo';
import { TagPrimaryColor } from '../../../shares/TagPrimaryColor';
import DashboardPageLayoutV2 from '../../../layout/dashboard/DashboardPageLayoutV2';
// import { FilterSortData } from '@shares/FilterSortData';

interface IFormFilterProps extends FormComponentProps {
  search: (values: any) => void;
  commonActionFromDALV2: any;
}
const FormFilterComponent = Form.create<IFormFilterProps>({
  name: 'filterform',
})((props: IFormFilterProps) => {
  const [visiblePermission, setVisiblePermission] = React.useState<boolean>(false);
  const { getFieldDecorator } = props.form;

  const onSearch = () => {
    props.form.validateFields((err: any, values: any) => {
      if (!err) {
        props.search(values);
      }
    });
  };

  return (
    <Form colon={false} layout='horizontal' title='Search'>
      <Row gutter={[5, 5]} type='flex' justify='start'>
        <Col xs={24} lg={6} style={{ flexGrow: 1 }}>
          <O2OFormItem label='Info'>
            {getFieldDecorator(
              'freeText',
              {}
            )(<Input.Search onPressEnter={onSearch} placeholder='Group name' allowClear></Input.Search>)}
          </O2OFormItem>
        </Col>
        <Col xs={24} lg={6} style={{ flexGrow: 1 }}>
          <SuggestionPermissionGroup
            commonActionFromDALV2={props.commonActionFromDALV2}
            form={props.form}
            keyField={'permission'}
            label='Permission'
            placeholder='Select one'
            onSelect={(e: string) => {}}
            visible={true}
          />
        </Col>
        <Col xs={24} lg={6} style={{ flexGrow: 1 }}>
          <SuggestionAccount
            commonActionFromDALV2={props.commonActionFromDALV2}
            form={props.form}
            keyField={'userId'}
            label='User'
            placeholder='Select one'
            onSelect={(e: string) => {}}
            visible={true}
          />
        </Col>
        <Col>
          <O2OFormItem label={<span style={{ color: '#fff' }}>Search</span>}>
            <Button onClick={onSearch} type='primary' icon='search'>
              Search
            </Button>
          </O2OFormItem>
        </Col>
        <Col>
          <O2OFormItem label={<span style={{ color: '#fff' }}></span>}>
            <Button
              type='primary'
              icon='ordered-list'
              onClick={() => {
                setVisiblePermission(true);
              }}
            >
              Permissions
            </Button>
          </O2OFormItem>
        </Col>

        <DrawerPermission
          onClose={() => {
            setVisiblePermission(false);
          }}
          visible={visiblePermission}
          commonActionFromDALV2={props.commonActionFromDALV2}
        />
      </Row>
    </Form>
  );
});

export class PermissionGroupComponentV2 extends React.Component<PermissionGroupsProps, any> {
  formRef: any;
  formFilter: any;
  state = {
    criteria: { page: 0, pageSize: 10, orderBy: 'createdAt:desc' } as IPermissionGroupCriteria,
    visible: false,
    selected: {} as TypePermissionGroup,
    visibleViewJSON: false,
    visiblePermissionGroupInfo: false,
    columns: [
      {
        title: '#',
        sorter: false,
        align: 'center',
        ellipsis: true,
        width: 40,
        render: (text: any, record: TypePermissionGroup, index: number) => {
          return index + 1;
        },
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: 300,
        render: (text: any, record: TypePermissionGroup, index: number) => {
          if (record.system) {
            return (
              <>
                <LongTextTd text={record.name} />
                <TagPrimaryColor style={{ marginLeft: 5 }} uiSetting={this.props.uiSetting} children={'System'} />
              </>
            );
          } else {
            return <LongTextTd text={record.name} />;
          }
        },
        ellipsis: true,
      },
      {
        title: 'Permission',
        dataIndex: 'permission',
        ellipsis: true,
        key: 'permission',
        width: 150,
        render: (text: any, record: TypePermissionGroup, index: number) => {
          return record.permissions && record.permissions.length > 0 ? (
            <Tooltip title={!this.state.grantPersmission && 'Missing Grant Permission'}>
              <Button
                disabled={!this.state.grantPersmission}
                style={{ marginLeft: -8 }}
                size='small'
                type='link'
                onClick={() => {
                  if (record.system) {
                    this.setState({
                      visiblePermissionGroupInfo: true,
                      selected: record,
                    });
                  } else {
                    this.setState({
                      visible: true,
                      selected: record,
                    });
                  }
                }}
              >
                {this.renderPermission(record.permissions.length)}
              </Button>
            </Tooltip>
          ) : (
            '--/--'
          );
        },
      },
      {
        title: 'User',
        dataIndex: 'user',
        ellipsis: true,
        key: 'user',
        width: 100,
        render: (text: any, record: TypePermissionGroup, index: number) => {
          const countUser =
            this.props.permissionGroups.users && this.props.permissionGroups.users[record.id]
              ? this.props.permissionGroups.users[record.id].length
              : 0;
          return (
            <>
              {countUser === 0 ? (
                <Tooltip title={this.state.grantPersmission ? 'Assign to users' : 'Missing Permission: GrantPrivilege'}>
                  <Button
                    disabled={!this.state.grantPersmission}
                    style={{ marginLeft: -5 }}
                    size='small'
                    type='link'
                    icon='plus-circle'
                    onClick={() => {
                      this.setState({
                        visibleAssign: true,
                        selected: record,
                      });
                    }}
                  ></Button>
                </Tooltip>
              ) : (
                <Tooltip title={this.state.grantPersmission ? 'Assign to users' : 'Missing Permission: GrantPrivilege'}>
                  <Button
                    disabled={!this.state.grantPersmission}
                    style={{ marginLeft: -8 }}
                    size='small'
                    type='link'
                    onClick={() => {
                      this.setState({
                        visibleAssign: true,
                        selected: record,
                      });
                    }}
                  >
                    {countUser === 1 ? `${countUser} user` : `${countUser} users`}
                  </Button>
                </Tooltip>
              )}
            </>
          );
        },
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 200,
        render: (text: any, record: TypePermissionGroup, index: number) => {
          return <LongTextTd text={record.description} />;
        },
        ellipsis: true,
      },
      {
        title: 'Creation Time',
        key: 'creation_time',
        width: 150,
        ellipsis: true,
        render(text: any, record: TypePermissionGroup, index: number) {
          return record.createdAt ? (
            <Tooltip
              title={`Created by ${record.createdBy} at ${moment(record.createdAt).format('DD/MM/YYYY HH:mm:ss')}`}
            >
              {moment(record.createdAt).fromNow()}
            </Tooltip>
          ) : (
            '--/--'
          );
        },
      },
      {
        title: 'Updated Time',
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        width: 150,
        ellipsis: true,
        render: (text: any, record: TypePermissionGroup, index: number) => {
          return record.updatedAt ? (
            <Tooltip
              title={`Updated by ${record.updatedBy} at ${moment(record.updatedAt).format('DD/MM/YYYY HH:mm:ss')}`}
            >
              {moment(record.updatedAt).fromNow()}
            </Tooltip>
          ) : (
            '--/--'
          );
        },
      },
      {
        title: 'Action',
        width: 140,
        fixed: 'right',
        render: (text: any, record: TypePermissionGroup, index: number) => {
          return (
            <React.Fragment>
              <Button
                onClick={() => {
                  this.setState({
                    visibleViewJSON: true,
                    selected: record,
                  });
                }}
                size='small'
                type='link'
                icon='select'
              />

              {!record.system ? (
                <>
                  <Divider type='vertical' />
                  <Tooltip title={this.state.grantPersmission ? '' : `Missing Grant Permission`}>
                    <Button
                      disabled={this.state.grantPersmission ? false : true}
                      size='small'
                      type='link'
                      icon='edit'
                      onClick={() => {
                        this.setState({
                          visible: true,
                          selected: record,
                        });
                      }}
                    ></Button>
                  </Tooltip>
                </>
              ) : null}

              {!record.system ? (
                <>
                  <Divider type='vertical' />
                  {this.state.grantPersmission ? (
                    <Popconfirm
                      title='Are you sure to delete this permission group?'
                      onConfirm={() => {
                        this.delete(record.id);
                      }}
                    >
                      <Button size='small' type='link' icon='delete'></Button>
                    </Popconfirm>
                  ) : (
                    <Tooltip title={`Missing Grant Permission`}>
                      <Button disabled size='small' type='link' icon='delete'></Button>
                    </Tooltip>
                  )}
                </>
              ) : null}
            </React.Fragment>
          );
        },
      },
    ] as ColumnProps<{}>[],
    visibleAssign: false,
    grantPersmission: false,
  };

  componentDidMount = () => {
    this.load();
    this.loadGrantPermission();
    this.props.updateMetaTitle({ title: BIGDATA_CONSTANT.trackTitle.ConsolePermissionGroup });
    this.timer = setTimeout(() => {
      this.props.updateMeta({
        name: BIGDATA_CONSTANT.trackTitle.ConsolePermissionGroup,
        title: BIGDATA_CONSTANT.trackTitle.ConsolePermissionGroup,
        app: 'ACCOUNT',
        url: getCurrentURL(this.props.location),
      });
      clearTimeout(this.timer);
    }, 5000);
  };

  timer: any;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  renderPermission = (length: number) => {
    if (length === 1) return '1 permission';
    else {
      return `${length} permissions`;
    }
  };

  delete = async (id: string) => {
    this.props.setGlobalLoading(true);
    const result = this.props.deletePermissionGroup(id);
    try {
      const response = await result;
      if (response.success) {
        this.props.setGlobalLoading(true);
        notification.success({
          message: BIGDATA_CONSTANT.message.default.title.success,
          description: BIGDATA_CONSTANT.message.notification.success.delete,
          icon: <Icon type='check-circle' style={{ color: getPrimaryColor(this.props.uiSetting) }} />,
        });
        setTimeout(() => {
          this.load();
        }, 1000);
      } else {
        notification.error({
          message: BIGDATA_CONSTANT.message.default.title.error,
          description: _.get(response, 'message', BIGDATA_CONSTANT.message.notification.fail.delete),
        });
        this.props.setGlobalLoading(false);
      }
    } catch (error) {
      notification.error({
        message: BIGDATA_CONSTANT.message.default.title.error,
        description: _.get(error, 'message', 'Something went wrong'),
      });
      this.props.setGlobalLoading(false);
    }
  };

  convertoPermissionName = (id: string) => {
    let item: TypePermission | undefined = _.find(
      this.props.permissions.results,
      (item: TypePermission) => item.id == id
    );
    return item ? item.name : '--';
  };

  load = () => {
    this.props.setGlobalLoading(true);
    Promise.all([this.props.searchPermission(), this.props.searchPermissionGroup(this.state.criteria)]).then(
      (result) => {
        this.props.setGlobalLoading(false);
      }
    );
  };

  checkCurrentUserIsSuperAdmin = (): boolean => {
    if (this.props.user) {
      if (this.props.user.orgCtx) {
        let roles = this.props.user.orgCtx.roles;
        let isSP = _.find(roles, (e) => {
          return e == 'SUPER_ADMIN';
        });

        if (isSP) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  };

  async loadGrantPermission() {
    const result = await this.props.commonActionFromDALV2(PermissionDAL.grantPermission);
    try {
      const response = await result;
      this.setState({
        grantPersmission: response.success,
      });
    } catch (error) {
      this.setState({
        grantPersmission: false,
      });
    }
  }

  renderRight = () => {
    return (
      <Tooltip title={!this.state.grantPersmission && 'Missing Grant Permission'}>
        <Button
          disabled={!this.state.grantPersmission}
          type='primary'
          icon='plus-circle'
          onClick={() => {
            this.setState({
              visible: true,
              selected: {},
            });
          }}
        >
          New Permission Group
        </Button>
      </Tooltip>
    );
  };

  renderContentLayout = (version?: string) => {
    return (
      <>
        <Row type='flex' gutter={[10, 10]}>
          <Col xs={24}>
            {(version === 'v1' || !version) && <Typography.Title level={4}>Permission Group</Typography.Title>}

            <FormFilterComponent
              search={(values: any) => {
                this.setState(
                  {
                    criteria: Object.assign(this.state.criteria, values),
                  },
                  () => {
                    this.load();
                  }
                );
              }}
              commonActionFromDALV2={this.props.commonActionFromDALV2}
            />
          </Col>

          <Col
            xs={24}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <InfoList list={this.props.permissionGroups} refresh={this.load} />
            {/* <FilterSortData
              items={[
                {
                  key: 'name',
                  name: 'Name',
                },
                {
                  key: 'createdAt',
                  name: 'Created At',
                },
                {
                  key: 'updatedAt',
                  name: 'Updated At',
                },
              ]}
              isLoading={this.props.ui.isLoading}
              orderBy={this.state.criteria.orderBy}
              onChangeOrderBy={(sort: any) => {
                this.setState(
                  {
                    criteria: Object.assign(this.state.criteria, { orderBy: sort, page: 0 }),
                  },
                  () => {
                    this.load();
                  }
                );
              }}
            /> */}
          </Col>

          <Col xs={24}>
            <Table
              size='small'
              bordered={false}
              columns={this.state.columns}
              dataSource={this.props.permissionGroups.results.content}
              pagination={false}
              scroll={{ x: 'calc(600px + 50%)' }}
            />
          </Col>

          <Col xs={24}>
            <O2OCustomPaging
              list={this.props.permissionGroups}
              onChangePageSize={(e: any) => {
                this.setState(
                  {
                    criteria: Object.assign(this.state.criteria, { page: 0, pageSize: e }),
                  },
                  () => {
                    this.load();
                  }
                );
              }}
              onChange={(e: any) => {
                this.setState(
                  {
                    criteria: Object.assign(this.state.criteria, { page: e - 1 }),
                  },
                  () => {
                    this.load();
                  }
                );
              }}
            />
          </Col>
        </Row>

        <DrawerPermissionGroupInfo
          onClose={() => {
            this.setState({
              visiblePermissionGroupInfo: false,
            });
          }}
          visible={this.state.visiblePermissionGroupInfo}
          permission={this.props.permissions}
          item={this.state.selected}
        />

        <DrawerCreatePermissionGroup
          onClose={() => {
            this.setState({
              visible: false,
            });
          }}
          visible={this.state.visible}
          permission={this.props.permissions}
          item={this.state.selected}
          updatePermissionGroup={this.props.updatePermissionGroup}
          onSuccess={() => {
            setTimeout(() => {
              this.load();
            }, 1000);
          }}
          createPermissionGroup={this.props.createPermissionGroup}
          commonActionFromDALV2={this.props.commonActionFromDALV2}
        />

        <DrawerAssignUser
          onClose={() => {
            this.setState({
              visibleAssign: false,
            });
          }}
          visible={this.state.visibleAssign}
          item={this.state.selected}
          onSuccess={() => {
            setTimeout(() => {
              this.load();
            }, 1000);
          }}
          commonActionFromDALV2={this.props.commonActionFromDALV2}
          userList={this.props.permissionGroups.users}
        />

        <DrawerViewJSON
          data={this.state.selected}
          visible={this.state.visibleViewJSON}
          onClose={() => {
            this.setState({
              visibleViewJSON: false,
              selected: {},
            });
          }}
        />
      </>
    );
  };

  render() {
    return (
      <DashboardPageLayoutV2
        props={this.props}
        selectedLeftNavStandard='group-permision'
        selectedSubMenuStandard='console'
        breadcrumbItemsStandard={[
          {
            title: 'Home',
            path: '/',
          },
          {
            title: 'Admin',
          },
          {
            title: 'Permission Group',
          },
        ]}
        breadcrumbItemsModern={[
          {
            title: 'Account',
            path: '/',
          },

          {
            title: 'Permission',
          },
        ]}
        pageTitle='Permission'
        renderContentLayout={this.renderContentLayout}
        metaTitle={this.props.ui.meta.title}
        pageTitleIcon={
          <Icon
            component={() => (
              <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M10.9556 10.6278L11.2922 10.5037C10.2352 9.98287 8.95914 9.6549 7.50143 9.6549C2.98288 9.6549 0.207764 12.8153 0.207764 15.0158C0.207764 15.8908 0.821556 16.2956 2.12096 16.2956H9.70681C9.67271 16.0809 9.65626 15.8513 9.65626 15.6035V15.2052H1.80101C1.48105 15.2052 1.36352 15.1203 1.36352 14.8852C1.36352 13.3638 3.57711 10.7519 7.50143 10.7519C8.48527 10.7519 9.36152 10.9156 10.1224 11.1848C10.3248 10.9499 10.5998 10.7591 10.9556 10.6278ZM7.51447 8.54489C9.49298 8.54489 11.0862 6.80147 11.0862 4.64009C11.0862 2.51797 9.49298 0.833313 7.51447 0.833313C5.54252 0.833313 3.93624 2.54409 3.93624 4.6532C3.93624 6.80796 5.53596 8.54489 7.51447 8.54489ZM7.51447 7.4544C6.18896 7.4544 5.09198 6.22684 5.09198 4.6532C5.09198 3.12523 6.1824 1.92377 7.51447 1.92377C8.84654 1.92377 9.93047 3.10565 9.93047 4.64009C9.93047 6.21381 8.84005 7.4544 7.51447 7.4544ZM15.5606 11.0258C15.1894 10.8904 14.8482 10.766 14.6384 10.6866C14.3837 10.6018 14.0833 10.5952 13.7961 10.7128C13.6258 10.7763 13.3468 10.8769 13.0318 10.9905C12.4405 11.2037 11.7226 11.4625 11.3605 11.6073C10.8708 11.8032 10.6945 12.0971 10.6945 12.5868V15.6231C10.6945 17.1706 11.5825 17.7387 13.8679 19.0708C14.0573 19.1818 14.3706 19.2144 14.6123 19.0708C16.9042 17.7322 17.7922 17.1706 17.7922 15.6231V12.5868C17.7922 12.0971 17.616 11.8032 17.1262 11.6073C16.7847 11.4723 16.1366 11.2359 15.5606 11.0258ZM13.7112 15.8973L15.768 13.0569C15.8594 12.9263 15.9966 12.8414 16.1728 12.8414C16.4341 12.8414 16.6561 13.0504 16.6561 13.3181C16.6561 13.4095 16.6169 13.514 16.5516 13.6119L14.1356 16.9617C14.0507 17.0727 13.9071 17.1445 13.7308 17.1445C13.6002 17.1445 13.45 17.0857 13.3455 16.9747L11.9416 15.4337C11.8502 15.3357 11.811 15.1921 11.811 15.0811C11.811 14.8069 12.02 14.5979 12.2877 14.5979C12.4575 14.5979 12.5816 14.6828 12.6664 14.7677L13.7112 15.8973Z'
                  fill='currentColor'
                />
              </svg>
            )}
          />
        }
        renderRight={this.renderRight}
      />
    );
  }
}
